<template class="font-mon">
  <div class="flex flex-col items-center w-full h-full justify-start bg-dark-black">

    <div class="absolute w-full h-fit flex justify-center items-center z-0">
      <svg width="1440" height="844" viewBox="0 0 1440 844" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect opacity="0.3" width="1440" height="843.75" transform="matrix(1 0 0 -1 0 843.75)"
          fill="url(#paint0_radial_474_919)" />
        <defs>
          <radialGradient id="paint0_radial_474_919" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
            gradientTransform="translate(720 843.75) scale(1109.2 1109.2)">
            <stop stop-color="#D7DF23" stop-opacity="0.5" />
            <stop offset="0.7" stop-opacity="0" />
          </radialGradient>
        </defs>
      </svg>
    </div>

    <Navbar />

    <div class="flex flex-col items-center w-full h-full pt-32 pb-20 justify-center max-w-7xl z-10">

      <section class="flex flex-col justify-center items-center mb-16 z-10">
        <div class="flex align-center justify-center md:px-16 px-4 w-full max-w-7xl">
          <div class="flex flex-col align-center justify-center gap-8">
            <div class="op-1 flex flex-col align-center">
              <h1 id="head-id" class="sm:text-3xl xl:text-7xl text-5xl font-extrabold text-white text-center">
                Discover Products
              </h1>
              <h1 id="head-id" class="sm:text-3xl xl:text-7xl text-5xl font-extrabold text-white text-center">
                <span class="text-white">With the Best Pricing</span>
              </h1>
            </div>
            <div class="op-2">
              <p class="text-2xl text-white opacity-75 flex justify-center text-center montserrat">
                Select from best plan, ensuring a perfect match. Need more or less?<br class="xl:block hidden" />
                Contact us to customize your subscription!
              </p>
            </div>
          </div>
        </div>
      </section>

      <div class="pricing-section">
        <!-- Monthly/Yearly Toggle -->
        <div class="toggle-container">
          <span :class="{ 'active': !isYearly }" class="font-semibold text-lg">Monthly</span>
          <label class="switch">
            <input type="checkbox" v-model="isYearly" @click="toggleYearly">
            <span class="slider round"></span>
          </label>
          <span :class="{ 'active': isYearly }" class="font-semibold text-lg">Yearly <span class="discount">Save
              20%</span></span>
        </div>

        <!-- Pricing Grid -->
        <div class="grid grid-cols-3 grid-flow-col items-start col-span-full w-full text-white lg:gap-16 gap-8 px-8">
          <!-- Basic Plan -->
          <div
            class="flex flex-col border-solid border-white border-1 border-t-2 rounded-2xl lg:p-16 p-8 items-start justify-start gap-2 text-white border-opacity-50 box-background h-full"
            style="min-width: 340px;">
            <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="0.608398" y="0.5" width="39" height="39" rx="19.5" fill="white" fill-opacity="0.12" />
              <rect x="0.608398" y="0.5" width="39" height="39" rx="19.5" stroke="url(#paint0_linear_433_1022)" />
              <path
                d="M30.1084 20C30.1084 25.5228 25.6312 30 20.1084 30C14.5856 30 10.1084 25.5228 10.1084 20C10.1084 14.4772 14.5856 10 20.1084 10C25.6312 10 30.1084 14.4772 30.1084 20ZM14.6084 20C14.6084 23.0376 17.0708 25.5 20.1084 25.5C23.146 25.5 25.6084 23.0376 25.6084 20C25.6084 16.9624 23.146 14.5 20.1084 14.5C17.0708 14.5 14.6084 16.9624 14.6084 20Z"
                fill="white" />
              <defs>
                <linearGradient id="paint0_linear_433_1022" x1="20.1084" y1="0" x2="20.1084" y2="40"
                  gradientUnits="userSpaceOnUse">
                  <stop stop-color="white" stop-opacity="0.16" />
                  <stop offset="1" stop-color="white" stop-opacity="0.02" />
                </linearGradient>
              </defs>
            </svg>
            <h6 class="text-2xl font-semibold mt-4 text-white">Basic</h6>
            <p class="text-sm opacity-70">Best for personal use</p>
            <h5 v-if="!isYearly" class="text-5xl font-bold mt-8 text-white">Free</h5>
            <h5 v-else class="text-5xl font-bold mt-8 text-white">Free</h5>
            <button
              class="text-sm w-full text-center border-white border-solid border-[1px] opacity-50 p-4 rounded-xl my-4 bg-transparent text-white hover:opacity-75">Get
              Started</button>
            <div class="w-full bg-white opacity-25 flex" style="height: 1px;"></div>
            <p class="mt-4 text-lg font-semibold">What you will get?</p>
            <span class="flex justify-start items-center flex-row gap-2 mt-4">
              <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12.8215 3.48466C15.4682 6.13133 15.4215 10.4513 12.6882 13.0446C10.1615 15.438 6.06154 15.438 3.52821 13.0446C0.788211 10.4513 0.741536 6.13133 3.39487 3.48466C5.99487 0.877996 10.2215 0.877996 12.8215 3.48466Z"
                  stroke="white" stroke-opacity="0.8" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M5.27441 8.18458L7.16108 10.0712L10.9411 6.29791" stroke="white" stroke-opacity="0.8"
                  stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <p class="text-sm">Basic features</p>
            </span>
            <span class="flex justify-start items-center flex-row gap-2 mt-2">
              <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12.8215 3.48466C15.4682 6.13133 15.4215 10.4513 12.6882 13.0446C10.1615 15.438 6.06154 15.438 3.52821 13.0446C0.788211 10.4513 0.741536 6.13133 3.39487 3.48466C5.99487 0.877996 10.2215 0.877996 12.8215 3.48466Z"
                  stroke="white" stroke-opacity="0.8" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M5.27441 8.18458L7.16108 10.0712L10.9411 6.29791" stroke="white" stroke-opacity="0.8"
                  stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <p class="text-sm">Limited storage</p>
            </span>
          </div>

          <!-- Pro Plan -->
          <div
            class="flex flex-col border-solid border-white border-1 border-t-2 rounded-2xl lg:p-16 p-8 items-start justify-start gap-2 text-white border-opacity-50 box-background h-full"
            style="min-width: 340px;">
            <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="0.608398" y="0.5" width="39" height="39" rx="19.5" fill="white" fill-opacity="0.12" />
              <rect x="0.608398" y="0.5" width="39" height="39" rx="19.5" stroke="url(#paint0_linear_433_1022)" />
              <path
                d="M30.1084 20C30.1084 25.5228 25.6312 30 20.1084 30C14.5856 30 10.1084 25.5228 10.1084 20C10.1084 14.4772 14.5856 10 20.1084 10C25.6312 10 30.1084 14.4772 30.1084 20ZM14.6084 20C14.6084 23.0376 17.0708 25.5 20.1084 25.5C23.146 25.5 25.6084 23.0376 25.6084 20C25.6084 16.9624 23.146 14.5 20.1084 14.5C17.0708 14.5 14.6084 16.9624 14.6084 20Z"
                fill="white" />
              <defs>
                <linearGradient id="paint0_linear_433_1022" x1="20.1084" y1="0" x2="20.1084" y2="40"
                  gradientUnits="userSpaceOnUse">
                  <stop stop-color="white" stop-opacity="0.16" />
                  <stop offset="1" stop-color="white" stop-opacity="0.02" />
                </linearGradient>
              </defs>
            </svg>
            <h6 class="text-2xl font-semibold mt-4 text-white">Pro</h6>
            <p class="text-sm opacity-70">Best for professionals</p>
            <h5 v-if="!isYearly" class="text-5xl font-bold mt-8 text-white">$15<span class="text-xl">/mo</span></h5>
            <h5 v-else class="text-5xl font-bold mt-8 text-white">$144<span class="text-xl">/yr</span></h5>
            <button
              class="text-sm w-full text-center border-white border-solid border-[1px] p-4 rounded-xl my-4 bg-white text-black hover:opacity-90">Get
              Started</button>
            <div class="w-full bg-white opacity-25 flex" style="height: 1px;"></div>
            <p class="mt-4 text-lg font-semibold">What you will get?</p>
            <span class="flex justify-start items-center flex-row gap-2 mt-4">
              <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12.8215 3.48466C15.4682 6.13133 15.4215 10.4513 12.6882 13.0446C10.1615 15.438 6.06154 15.438 3.52821 13.0446C0.788211 10.4513 0.741536 6.13133 3.39487 3.48466C5.99487 0.877996 10.2215 0.877996 12.8215 3.48466Z"
                  stroke="white" stroke-opacity="0.8" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M5.27441 8.18458L7.16108 10.0712L10.9411 6.29791" stroke="white" stroke-opacity="0.8"
                  stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <p class="text-sm">All Basic features</p>
            </span>
            <span class="flex justify-start items-center flex-row gap-2 mt-2">
              <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12.8215 3.48466C15.4682 6.13133 15.4215 10.4513 12.6882 13.0446C10.1615 15.438 6.06154 15.438 3.52821 13.0446C0.788211 10.4513 0.741536 6.13133 3.39487 3.48466C5.99487 0.877996 10.2215 0.877996 12.8215 3.48466Z"
                  stroke="white" stroke-opacity="0.8" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M5.27441 8.18458L7.16108 10.0712L10.9411 6.29791" stroke="white" stroke-opacity="0.8"
                  stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <p class="text-sm">50GB storage</p>
            </span>
            <span class="flex justify-start items-center flex-row gap-2 mt-2">
              <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12.8215 3.48466C15.4682 6.13133 15.4215 10.4513 12.6882 13.0446C10.1615 15.438 6.06154 15.438 3.52821 13.0446C0.788211 10.4513 0.741536 6.13133 3.39487 3.48466C5.99487 0.877996 10.2215 0.877996 12.8215 3.48466Z"
                  stroke="white" stroke-opacity="0.8" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M5.27441 8.18458L7.16108 10.0712L10.9411 6.29791" stroke="white" stroke-opacity="0.8"
                  stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <p class="text-sm">Premium support</p>
            </span>
          </div>

          <!-- Enterprise Plan -->
          <div
            class="flex flex-col border-solid border-white border-1 border-t-2 rounded-2xl lg:p-16 p-8 items-start justify-start gap-2 text-white border-opacity-50 box-background h-full"
            style="min-width: 340px;">
            <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="0.608398" y="0.5" width="39" height="39" rx="19.5" fill="white" fill-opacity="0.12" />
              <rect x="0.608398" y="0.5" width="39" height="39" rx="19.5" stroke="url(#paint0_linear_433_1022)" />
              <path
                d="M30.1084 20C30.1084 25.5228 25.6312 30 20.1084 30C14.5856 30 10.1084 25.5228 10.1084 20C10.1084 14.4772 14.5856 10 20.1084 10C25.6312 10 30.1084 14.4772 30.1084 20ZM14.6084 20C14.6084 23.0376 17.0708 25.5 20.1084 25.5C23.146 25.5 25.6084 23.0376 25.6084 20C25.6084 16.9624 23.146 14.5 20.1084 14.5C17.0708 14.5 14.6084 16.9624 14.6084 20Z"
                fill="white" />
              <defs>
                <linearGradient id="paint0_linear_433_1022" x1="20.1084" y1="0" x2="20.1084" y2="40"
                  gradientUnits="userSpaceOnUse">
                  <stop stop-color="white" stop-opacity="0.16" />
                  <stop offset="1" stop-color="white" stop-opacity="0.02" />
                </linearGradient>
              </defs>
            </svg>
            <h6 class="text-2xl font-semibold mt-4 text-white">Enterprise</h6>
            <p class="text-sm opacity-70">Best for organizations</p>
            <h5 v-if="!isYearly" class="text-5xl font-bold mt-8 text-white">$49<span class="text-xl">/mo</span></h5>
            <h5 v-else class="text-5xl font-bold mt-8 text-white">$470<span class="text-xl">/yr</span></h5>
            <button
              class="text-sm w-full text-center border-white border-solid border-[1px] opacity-50 p-4 rounded-xl my-4 bg-transparent text-white hover:opacity-75">Get
              Started</button>
            <div class="w-full bg-white opacity-25 flex" style="height: 1px;"></div>
            <p class="mt-4 text-lg font-semibold">What you will get?</p>
            <span class="flex justify-start items-center flex-row gap-2 mt-4">
              <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12.8215 3.48466C15.4682 6.13133 15.4215 10.4513 12.6882 13.0446C10.1615 15.438 6.06154 15.438 3.52821 13.0446C0.788211 10.4513 0.741536 6.13133 3.39487 3.48466C5.99487 0.877996 10.2215 0.877996 12.8215 3.48466Z"
                  stroke="white" stroke-opacity="0.8" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M5.27441 8.18458L7.16108 10.0712L10.9411 6.29791" stroke="white" stroke-opacity="0.8"
                  stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <p class="text-sm">All Pro features</p>
            </span>
            <span class="flex justify-start items-center flex-row gap-2 mt-2">
              <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12.8215 3.48466C15.4682 6.13133 15.4215 10.4513 12.6882 13.0446C10.1615 15.438 6.06154 15.438 3.52821 13.0446C0.788211 10.4513 0.741536 6.13133 3.39487 3.48466C5.99487 0.877996 10.2215 0.877996 12.8215 3.48466Z"
                  stroke="white" stroke-opacity="0.8" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M5.27441 8.18458L7.16108 10.0712L10.9411 6.29791" stroke="white" stroke-opacity="0.8"
                  stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <p class="text-sm">Unlimited storage</p>
            </span>
            <span class="flex justify-start items-center flex-row gap-2 mt-2">
              <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12.8215 3.48466C15.4682 6.13133 15.4215 10.4513 12.6882 13.0446C10.1615 15.438 6.06154 15.438 3.52821 13.0446C0.788211 10.4513 0.741536 6.13133 3.39487 3.48466C5.99487 0.877996 10.2215 0.877996 12.8215 3.48466Z"
                  stroke="white" stroke-opacity="0.8" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M5.27441 8.18458L7.16108 10.0712L10.9411 6.29791" stroke="white" stroke-opacity="0.8"
                  stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <p class="text-sm">Dedicated account manager</p>
            </span>
            <span class="flex justify-start items-center flex-row gap-2 mt-2">
              <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12.8215 3.48466C15.4682 6.13133 15.4215 10.4513 12.6882 13.0446C10.1615 15.438 6.06154 15.438 3.52821 13.0446C0.788211 10.4513 0.741536 6.13133 3.39487 3.48466C5.99487 0.877996 10.2215 0.877996 12.8215 3.48466Z"
                  stroke="white" stroke-opacity="0.8" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M5.27441 8.18458L7.16108 10.0712L10.9411 6.29791" stroke="white" stroke-opacity="0.8"
                  stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <p class="text-sm">Custom integration</p>
            </span>
          </div>
        </div>

      </div>
    </div>

    <Footer></Footer>

  </div>
</template>

<script>
import Footer from './components/homepage/Footer.vue';
import Navbar from './NavbarNew.vue';

export default {
  name: 'Pricing',
  components: {
    Navbar,
    Footer,
  },
data() {
    return {
      isYearly: false
    }
  },
  methods: {
    toggleYearly() {
      // This method explicitly sets isYearly to true when the switch is clicked
      // Note: v-model already handles the toggle, but this ensures it's set to true when clicked
      this.isYearly = true;
    }
  }
}
</script>

<style scoped>
.pricing-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.toggle-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 40px;
  color: white;
  gap: 16px;
}

.active {
  font-weight: 600;
  color: #D7DF23;
}

.discount {
  background-color: rgba(255, 255, 255, 0.2);
  padding: 4px 8px;
  border-radius: 16px;
  font-size: 12px;
  margin-left: 8px;
}

.box-background {
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
}

/* Switch toggle styling */
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.2);
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: .4s;
}

input:checked+.slider {
  background-color: rgba(255, 255, 255, 0.4);
}

input:checked+.slider:before {
  transform: translateX(26px);
}

.slider.round {
  border-radius: 10px;
}

.slider.round:before {
  border-radius: 10px;
}
</style>